"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSlugFromDictionary = void 0;
var sanitizeFileName = require("sanitize-filename");
var escapeName = function (fileName) {
    return fileName.replace(/\s/g, "_").replace(/^\./, "_");
};
/**
 * Create fileName-safe slug string from dictionary
 * @param {Dictionary} dictionary
 * @returns {string}
 */
function createSlugFromDictionary(dictionary) {
    return sanitizeFileName(escapeName(dictionary.expected.value));
}
exports.createSlugFromDictionary = createSlugFromDictionary;
//# sourceMappingURL=DictionarySlugCreator.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionarySlugCreator.js
// module id = 978
// module chunks = 0